import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';
const stylesBt = theme => ({
    button: {
        margin: theme.spacing.unit,
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
});

class Numpad extends React.Component {
    state = {

    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    };

    handleClose = value => {
        this.setState({ open: false });
    };

    render() {
        const { classes, width } = this.props;
        let bWidth = width/3;
        return (
            <div style={{width,height:width+width/3,textAlign:'center',backgroundColor:"#538234",color:'white',fontSize:'1.4rem'}}>
                <Grid container direction="row" alignItems="center" justify="center" style={{width:"100%",height:bWidth}}>
                    <Grid item xs={4} >
                    <Button onClick={()=>this.props.handleClick("1")} style={{backgroundImage:'url(/assets/web/numb_bg.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth}} color="secondary"  variant="contained"  >
                            1
                            </Button>
                    </Grid>
                    <Grid item xs={4} >
                    <Button onClick={()=>this.props.handleClick("2")} style={{backgroundImage:'url(/assets/web/numb_bg.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth}} color="secondary"  variant="contained"  >
                            2
                            </Button>
                    </Grid>
                    <Grid item xs={4} >
                    <Button onClick={()=>this.props.handleClick("3")} style={{backgroundImage:'url(/assets/web/numb_bg.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth}} color="secondary"  variant="contained"  >
                            3
                            </Button>
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="center" justify="center" style={{width:"100%",height:bWidth}}>
                    <Grid item xs={4} >
                    <Button onClick={()=>this.props.handleClick("4")} style={{backgroundImage:'url(/assets/web/numb_bg.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth}} color="secondary"  variant="contained"  >
                            4
                            </Button>
                    </Grid>
                    <Grid item xs={4} >
                    <Button onClick={()=>this.props.handleClick("5")} style={{backgroundImage:'url(/assets/web/numb_bg.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth}} color="secondary"  variant="contained"  >
                            5
                            </Button>
                    </Grid>
                    <Grid item xs={4} >
                    <Button onClick={()=>this.props.handleClick("6")} style={{backgroundImage:'url(/assets/web/numb_bg.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth}} color="secondary"  variant="contained"  >
                            6
                            </Button>
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="center" justify="center" style={{width:"100%",height:bWidth}}>
                    <Grid item xs={4} >
                    <Button onClick={()=>this.props.handleClick("7")} style={{backgroundImage:'url(/assets/web/numb_bg.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth}} color="secondary"  variant="contained"  >
                            7
                            </Button>
                    </Grid>
                    <Grid item xs={4} >
                    <Button onClick={()=>this.props.handleClick("8")} style={{backgroundImage:'url(/assets/web/numb_bg.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth}} color="secondary"  variant="contained"  >
                            8
                            </Button>
                    </Grid>
                    <Grid item xs={4} >
                    <Button onClick={()=>this.props.handleClick("9")} style={{backgroundImage:'url(/assets/web/numb_bg.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth}} color="secondary"  variant="contained"  >
                            9
                            </Button>
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="center" justify="center" style={{width:"100%",height:bWidth}}>
                    <Grid item xs={4} >
                      <Button onClick={()=>this.props.handleClick("0")} style={{backgroundImage:'url(/assets/web/numb_bg.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth}} color="secondary"  variant="contained"  >
                              0
                              </Button>

                    </Grid>
                    <Grid item xs={4} >
                      <Button onClick={()=>this.props.handleClick("-1")} style={{backgroundImage:'url(/assets/web/numb_bg.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth}} color="secondary"  variant="contained"  >
                              X
                              </Button>
                    </Grid>
                    <Grid item xs={4} >
                      <Button onClick={()=>this.props.handleClick("Enter")}  style={{backgroundImage:'url(/assets/web/numb_bg.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.8rem",width:bWidth,height:bWidth}} color="secondary"  variant="contained"  >
                        <KeyboardReturnIcon style={{ color: '#538234', fontSize:"1.8rem" }}  />
                              </Button>

                    </Grid>
                </Grid>
            </div>
        );
    }
}

Numpad.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(stylesBt)(Numpad);
